import * as CONST from '@Bootstraps/bootstrapConstants';

export const setAuth = payload => ({
  type: CONST.SET_AUTH,
  payload,
});
export const setCart = payload => ({
  type: CONST.SET_CART,
  payload,
});

export const registration = payload => ({
  type: CONST.REGISTRATION,
  payload
});
export const registrationFailed = payload => ({
  type: CONST.REGISTRATION_FAILED,
  payload
});
export const registrationSuccess = payload => ({
  type: CONST.REGISTRATION_SUCCESS,
  payload
});

export const login = payload => ({
  type: CONST.LOGIN,
  payload,
});
export const loginFailed = payload => ({
  type: CONST.LOGIN_FAILED,
  payload,
});
export const loginSuccess = payload => ({
  type: CONST.LOGIN_SUCCESS,
  payload,
});

export const removeAccount = payload => ({
  type: CONST.REMOVE_ACCOUNT,
  payload,
});
export const removeAccountFailed = payload => ({
  type: CONST.REMOVE_ACCOUNT_FAILED,
  payload,
});
export const removeAccountSuccess = payload => ({
  type: CONST.REMOVE_ACCOUNT_SUCCESS,
  payload,
});

export const clothesInquiry = payload => ({
  type: CONST.CLOTHES_INQUIRY,
  payload,
});
export const clothesInquiryFailed = payload => ({
  type: CONST.CLOTHES_INQUIRY_FAILED,
  payload,
});
export const clothesInquirySuccess = payload => ({
  type: CONST.CLOTHES_INQUIRY_SUCCESS,
  payload,
});

export const clothesEntity = payload => ({
  type: CONST.CLOTHES_ENTITY,
  payload,
});
export const clothesEntityFailed = payload => ({
  type: CONST.CLOTHES_ENTITY_FAILED,
  payload,
});
export const clothesEntitySuccess = payload => ({
  type: CONST.CLOTHES_ENTITY_SUCCESS,
  payload,
});

export const clothesInsert = payload => ({
  type: CONST.CLOTHES_INSERT,
  payload,
});
export const clothesInsertFailed = payload => ({
  type: CONST.CLOTHES_INSERT_FAILED,
  payload,
});
export const clothesInsertSuccess = payload => ({
  type: CONST.CLOTHES_INSERT_SUCCESS,
  payload,
});

export const clothesUpdate = payload => ({
  type: CONST.CLOTHES_UPDATE,
  payload,
});
export const clothesUpdateFailed = payload => ({
  type: CONST.CLOTHES_UPDATE_FAILED,
  payload,
});
export const clothesUpdateSuccess = payload => ({
  type: CONST.CLOTHES_UPDATE_SUCCESS,
  payload,
});

export const clothesDelete = payload => ({
  type: CONST.CLOTHES_DELETE,
  payload,
});
export const clothesDeleteFailed = payload => ({
  type: CONST.CLOTHES_DELETE_FAILED,
  payload,
});
export const clothesDeleteSuccess = payload => ({
  type: CONST.CLOTHES_DELETE_SUCCESS,
  payload,
});